/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.strings.internal

import features.strings.models.ApplicationStringsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class StringsRequest : NetworkRequest() {

    suspend fun getStrings(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<ApplicationStringsModel> {
        return safeNetworkCall {
            get(
                endpoint = StringsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
